import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Loader } from "@/components/ui-kit";
import { usePartnerMeta, can } from "@/lib/partner";
import { Sel } from "@/components/partner/PartnerDialogs";
import { User } from "lucide-react";
import { toast } from "sonner";

export default function PartnerPipelines() {
  const [meta] = usePartnerMeta();
  const nav = useNavigate();
  const [pid, setPid] = useState("");
  const [items, setItems] = useState([]);
  const [drag, setDrag] = useState(null);
  const pipes = (meta?.pipelines || []).filter((p) => p.actif !== false);
  const pipe = pipes.find((p) => p.id === pid) || pipes[0];
  const load = () => pipe && api.get("/partners", { params: { pipeline_id: pipe.id } }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [pipe?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!meta) return <Loader />;
  const drop = async (stageId) => {
    const p = items.find((x) => x.id === drag);
    setDrag(null);
    if (!p || p.stage_id === stageId) return;
    try { await api.post(`/partners/${p.id}/move`, { stage_id: stageId }); toast.success("Étape mise à jour"); load(); } catch (e) { toast.error(apiErr(e)); }
  };
  const movable = can(meta, "move");
  return (
    <div data-testid="partner-pipelines">
      <PageHeader title="Pipelines de partenariat" subtitle={movable ? "Glissez une fiche d'une colonne à l'autre pour changer son étape." : "Lecture seule : droit « Déplacer » requis."}>
        <div className="w-80"><Sel value={pipe?.id} onChange={setPid} options={pipes.map((p) => [p.id, p.nom])} testid="pipeline-select" /></div>
      </PageHeader>
      {pipe && <div className="flex gap-3 overflow-x-auto pb-4 scrollbar-thin">
        {pipe.stages.map((s) => {
          const col = items.filter((p) => p.stage_id === s.id);
          return (
            <div key={s.id} onDragOver={(e) => movable && e.preventDefault()} onDrop={() => drop(s.id)} className={`w-64 shrink-0 rounded-xl border-t-4 bg-slate-50 p-2 ${s.terminal === "won" ? "border-t-emerald-500" : s.terminal === "lost" ? "border-t-rose-400" : "border-t-brand-500"}`} data-testid={`kanban-col-${s.id}`}>
              <p className="text-xs font-semibold px-1 mb-2 flex justify-between"><span>{s.nom}</span><span className="text-slate-400">{col.length}</span></p>
              <div className="space-y-2 min-h-16">{col.map((p) => (
                <div key={p.id} draggable={movable} onDragStart={() => setDrag(p.id)} onClick={() => nav(`/partenariat/fiche/${p.id}`)} className="rounded-lg bg-white border p-2 cursor-pointer hover:shadow-sm" data-testid={`kanban-card-${p.id}`}>
                  <p className="text-sm font-medium">{p.nom}</p><p className="text-[11px] text-slate-500">{p.categorie}</p>
                  <p className="text-[11px] text-slate-400 mt-1"><User className="inline h-3 w-3 mr-0.5" />{p.responsable_name}</p>
                </div>))}</div>
            </div>
          );
        })}
      </div>}
    </div>
  );
}
